import DataGrid, { Column, DataGridTypes, Format, Summary, TotalItem } from 'devextreme-react/data-grid';
import { formatNumber } from 'devextreme/localization';
import { useCallback, useContext } from 'react';
import { MaterialOrderContext } from '../../material-order/context/MaterialOrderContext';
import { RetailOrderContext } from '../context/RetailOrderContext';
import { Popover } from "devextreme-react/popover";
import { ROType } from '../../../../types/enums';

export default function RetailOrderProducts(props: { showMaterialOrderInSummary?: boolean }) {

    const { order: retailOrder } = useContext(RetailOrderContext);
    const { order: materialOrder } = useContext(MaterialOrderContext);

    const renderItemDescriptionGridCell = (data: DataGridTypes.ColumnCellTemplateData) => {
        return <>{data.data.itemDescription}
            {data.data.isQuickShip ? <>
                <span
                    className='round-label'
                    id={'id-itemDescription-' + data.data.roProductID}
                >Quick Ship</span>
                <Popover
                    target={'#id-itemDescription-' + data.data.roProductID}
                    showEvent="mouseenter"
                    hideEvent="mouseleave"
                    position="top"
                    width={300}
                >
                    Quick Ship Program.
                </Popover></> : <></>}</>;
    }

    let estCfiPay = retailOrder.details.amount;
    if (retailOrder.details.materialOrders) {
        retailOrder.details.materialOrders.forEach((mo) => {
            estCfiPay -= mo.amount;
        });
    }

    if (materialOrder.details && !materialOrder.details.materialOrderID) {
        estCfiPay -= materialOrder.details.amount;
    }

    const rowPrepared = useCallback((e: any) => {
        if (e.data !== undefined) {
            if (e.data.isQuickShip) {
                e.rowElement.classList.add("quick-ship-order-highlighted");
            }
        }
    }, []);

    return (
        <div className='dx-card wide-card'>
            <div className='grid-header'>Retail Order Details</div>
            <DataGrid
                dataSource={retailOrder.details.products}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                showColumnLines={true}
                columnAutoWidth={true}
                keyExpr={'roProductID'}
                className="grid-with-header"
                onRowPrepared={rowPrepared}
            >
                <Column
                    dataField={'itemDescription'}
                    caption={'Item Description'}
                    dataType="string"
                    cellRender={renderItemDescriptionGridCell}
                />
                {
                    retailOrder.details.roTypeID !== ROType.Plumbing &&
                    <Column
                        dataField={'thickness'}
                        caption={'Thickness'}
                        dataType="string"
                    />
                }
                <Column
                    dataField={'productType'}
                    caption={'Product Type'}
                    dataType="string"
                />
                <Column
                    dataField={'productLineDescription'}
                    caption={'Product Line'}
                    dataType="string"
                />
                <Column
                    dataField={'dealerSKU'}
                    caption={'SKU'}
                    dataType="string"
                />
                <Column
                    dataField={'dealerUOM'}
                    caption={'UOM'}
                    dataType="string"
                />
                <Column
                    dataField={'dealerQty'}
                    caption={'Qty'}
                    dataType="number"
                />
                <Column
                    dataField={'cfiPrice'}
                    caption={'Price'}
                    dataType="number"
                >
                    <Format type="currency" precision={2}></Format>
                </Column>
                <Column
                    dataField={'cfiExtendedPrice'}
                    caption={'Extended Price'}
                    dataType="number"
                >
                    <Format type="currency" precision={2}></Format>
                </Column>
                {
                    !props.showMaterialOrderInSummary &&
                    <Summary>
                        <TotalItem
                            column="cfiExtendedPrice"
                            summaryType="sum"
                            customizeText={(data: any) => 'Total: ' + formatNumber(data.value, {
                                type: 'currency',
                                precision: 2
                            })}
                        />
                    </Summary>
                }
            </DataGrid>
            {
                props.showMaterialOrderInSummary &&
                <div className='dx-clearfix'>
                    <table className='summary-table'>
                        <tbody>
                            <tr>
                                <td>Total:</td>
                                <td>{formatNumber(retailOrder.details.amount, { type: 'currency', precision: 2 })}</td>
                            </tr>
                            {
                                materialOrder.details && !materialOrder.details.materialOrderID &&
                                <tr>
                                    <td>MO in process:</td>
                                    <td>{formatNumber(-materialOrder.details.amount, {
                                        type: 'currency',
                                        precision: 2,
                                        useCurrencyAccountingStyle: false
                                    })}</td>
                                </tr>
                            }
                            {
                                retailOrder.details.materialOrders?.map((mo) => {
                                    return (
                                        <tr key={mo.materialOrderID}>
                                            <td>{mo.moNumber}:</td>
                                            <td>{formatNumber(-mo.amount, {
                                                type: 'currency',
                                                precision: 2,
                                                useCurrencyAccountingStyle: false
                                            })}</td>
                                        </tr>
                                    )
                                })
                            }
                            <tr className='total'>
                                <td>Est. CFI Pay:</td>
                                <td>{formatNumber(estCfiPay, {
                                    type: 'currency',
                                    precision: 2,
                                    useCurrencyAccountingStyle: false
                                })}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            }
        </div>
    );
}
